<template>
    <b-modal id="project-style-guide" centered scrollable hide-footer modal-class="modal-full-height">
        <template #modal-title>
            <p tabindex="0" class="title">{{styleGuide.title}} </p>
        </template>
        <div class="content-style-guide">
            <div v-if="getImage" class="content-style-guide__image">
                <img width="100%" :src="getImage" :alt="styleGuide.title">
            </div>
            <div role="dialog" class="content-style-guide__body">
                <div :class="{'content-style-guide__body-item':!item.isTip, 'content-style-guide__body-item_tip':item.isTip}" :key="index" v-for="(item, index) in styleGuide.content" >
                    <p class="mb-3" v-if="!item.isTip" tabindex="0">{{item.title}}</p>
                    <p class="mb-3" tabindex="0" v-else ><span class="icon icon-tip"></span><span class="text">{{item.title}}</span></p>
                    <p class="mb-3" tabindex="0" v-for="description in item.body">
                        {{description}}
                    </p>
                    <a  v-if="item.link" :href="item.link" class="link" target="_blank"><span v-if="item.textvideo" >{{item.textvideo}}</span></a>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
    export default {
        name: "ProjectStyleGuide",
        components: {},
        props:{
            styleGuide: {
                type: Object,
                required:true
            },
        },
        computed: {
            getImage() {
                if(!this.styleGuide.image){
                    return null
                }
                return require("../Images/style_guides/"+ this.styleGuide.image.filename)
            },
        },
    }
</script>

<style lang="stylus" scoped>

    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"
   
    .font-size 
        .modal-full-height.modal
            height -webkit-fill-available !important
    .content-style-guide
        display flex
        flex-direction column
        &>*
            flex 1
            padding-top 30px
        &__image
            padding-left 10px
            padding-right 10px
        &__body
            padding-bottom 25px
            &-item_tip
            &-item
                padding-bottom 35px
                h3
                    font font-poppins-semibold
                    font-size 16px
                    color color-black
                p
                    font font-sourcesans-regular
                    font-size 16px
                    color color-4
                    margin 0
                    &:first-child 
                        font-weight bold
                    &:last-child
                        padding-bottom 0 
                a
                    margin-top -15px !important
                    display block
                

            &-item_tip
                background-color color-31
                min-height  202px
                box-shadow: inset 0 0 0 1px color-2;
                border color-31 10px solid;
                padding 17px 17px 30px 17px

                h3
                    .icon
                        width 20px
                    .text
                        text-transform uppercase
                        font inherit
                        color color-2
                        padding-left 8px
                p
                    color color-black


    .title
        font font-poppins-regular
        font-size 1em
        color color-black
        
    .icon-tip
        margin-right 5px
        margin-bottom 2px
    
</style>

